const EmptyState = ({ title = "No results found", message = "Try adjusting your filters or search query.", icon }) => {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      {icon || (
        <svg className="w-16 h-16 text-gray-300 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      )}
      <h3 className="text-lg font-medium text-gray-700">{title}</h3>
      <p className="text-sm text-gray-500 mt-1 max-w-sm">{message}</p>
    </div>
  );
};

export default EmptyState;
